export const PREPARE_SESSION_LINK_INTENT = {
  OFFICIAL: 'official',
  EXTRAORDINARY: 'extraordinary',
  UNASSIGNED: 'unassigned',
} as const;

export type PrepareSessionLinkIntent =
  (typeof PREPARE_SESSION_LINK_INTENT)[keyof typeof PREPARE_SESSION_LINK_INTENT];

export const PREPARE_SESSION_RECORD_SOURCE = {
  OFFICIAL_EXISTING: 'official_existing',
  OFFICIAL_CREATED: 'official_created',
  ADHOC: 'adhoc',
} as const;

export type PrepareSessionRecordSource =
  (typeof PREPARE_SESSION_RECORD_SOURCE)[keyof typeof PREPARE_SESSION_RECORD_SOURCE];

export interface PrepareAttendanceSessionRequest {
  localSessionId: string;
  shiftStartAtDevice: string;
  linkIntent: PrepareSessionLinkIntent;
}

export interface PrepareAttendanceSessionsParams {
  organizationId: string;
  /** Admin-only target employee; omitted for self-service preparation. */
  employeeId?: string;
  sessions: PrepareAttendanceSessionRequest[];
}

export interface PreparedAttendanceSession {
  localSessionId: string;
  recordId: string;
  recordSource: PrepareSessionRecordSource;
}

export interface PrepareAttendanceSessionsResponse {
  sessions: PreparedAttendanceSession[];
}
